import { Hero } from '@/components/organisms/Admin/ProgressCheck/Hero'
import { Steps } from '@/components/organisms/Admin/ProgressCheck/Steps'

export function ProgressCheckPage() {
	return (
		<div className='flex flex-col w-full relative z-10 overflow-clip'>
			<Hero />
			<Steps />
		</div>
	)
}
